/**
 * Стек шарів, які закриває Esc (UIUX/patterns/keyboard: «Esc closes the topmost layer only»): відкриті плаваючі списки реєструють
 * закриття; один слухач на window у фазі перехоплення ставиться під час завантаження модуля — раніше за слухачі діалогів і панелей —
 * і, якщо стек не порожній, закриває лише верхній шар і зупиняє подію (stopImmediatePropagation), тож панель чи діалог під списком
 * лишаються відкритими.
 */
const stack: Array<() => void> = [];

if (typeof window !== 'undefined') {
  window.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || !stack.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    stack[stack.length - 1]!();
  }, true);
}

/** Додає шар до стека; повертає функцію, що прибирає його (після закриття списку). */
export function pushEscapeLayer(close: () => void): () => void {
  stack.push(close);
  return () => {
    const i = stack.lastIndexOf(close);
    if (i >= 0) stack.splice(i, 1);
  };
}
